import classNames from "classnames";
import * as React from "react";

import styles from "./styles.scss";

interface Props extends React.Attributes {
  children: React.ReactNode;
  shouldCloseOnClick?: boolean;
  disabled?: boolean;
}

const Container = (props: Props) => {
  const { shouldCloseOnClick = true, disabled, children } = props;
  const [listVisible, setListVisible] = React.useState(false);
  const ref = React.useRef<HTMLSpanElement>(null);

  const closeList = React.useCallback(
    (e: any) => {
      if (ref.current && ref.current.contains(e.target)) {
        return;
      }

      if (listVisible) {
        setListVisible(false);
      }
    },
    [listVisible],
  );

  const handleClick = React.useCallback(() => {
    if (disabled) {
      return;
    }
    if (shouldCloseOnClick) {
      setListVisible(!listVisible);
    } else {
      setListVisible(true);
    }
  }, [disabled, shouldCloseOnClick, listVisible]);

  return (
    <>
      {listVisible ? (
        <div className={styles.backdrop} onClick={closeList} />
      ) : null}
      <span
        className={classNames(styles.container, {
          [styles.listVisible]: listVisible,
        })}
        onClick={handleClick}
        ref={ref}
      >
        {children}
      </span>
    </>
  );
};

export default Container;
